import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { UserService } from '../../services/user.service';
import { ProductService } from '../../services/product.service';


/**
 * Component for emailing selected products.
 */
@Component({
	selector: 'email-products',
	templateUrl: './email-products.component.html',
	styleUrl: './email-products.component.css'
})
export class EmailProductsComponent implements OnInit {
	@Input() productGroup: any;

	LOCALIZATION: any;
	input = {
		emails: [] as string[],
		email: '',
		isFile: false,
		allMetadata: true,
		format: 'txt',
		subject: '',
		message: ''
	};
	userInput = {
		limit: 300,
		chars: 0
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private productService: ProductService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	onUserChars(message: string): void {
		this.userInput.chars = message ? message.length : 0;
	}

	addEmail(): void {
		if (this.input.email && this.input.email != "") {
			this.input.emails.push(this.input.email);
		}
		this.input.email = "";
	}

	removeEmail(email: string): void {
		let index: number;
		while ((index = this.input.emails.indexOf(email)) !== -1) {
			this.input.emails.splice(index, 1);
		}
	}

	/**
	 * Emails the products.
	 */
	send(): void {
		if (this.input.emails.indexOf(this.input.email) == -1 && this.input.email.length > 0) {
			this.input.emails.push(this.input.email);
		}

		if (this.input.emails.length == 0) {
			this.alertsService.error({
				message: "The email list is empty."
			});
			return;
		}

		var payload = {
			isFile: this.input.isFile,
			emails: this.input.emails.join(','),
			format: this.input.format,
			subject: this.input.subject,
			message: this.input.message,
			AllMetadata: this.input.allMetadata,
			id: '',
			page: ''
		};

		if (this.productGroup.ids) {
			this.productService.sendProducts(this.productGroup.ids, payload).then(
				(response: any) => {
					this.alertsService.success({
						message: "Documents have been sent to the provided emails.",
						delay: 5000
					});

					this.close();
				},
				() => {
					this.alertsService.error({
						message: "Failed to send the documents."
					});
				}
			);
		} else {
			payload.id = this.productGroup.id;
			payload.page = this.productGroup.page;
			this.productService.sendProductPage(payload).then(
				(response: any) => {
					this.alertsService.success({
						message: "The page was sent to the provided emails.",
						delay: 5000
					});

					this.close();
				},
				() => {
					this.alertsService.error({
						message: "Failed to send the page."
					});
				}
			);
		}
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
